var $4ec2e5b6623b1b76$exports = {};
$4ec2e5b6623b1b76$exports = {
    "dropzoneLabel": `Strefa upuszczania`,
    "selectPlaceholder": `Wybierz element`,
    "tableResizer": `Zmiana rozmiaru`,
    "colorSwatchPicker": `Color swatches`
};


export {$4ec2e5b6623b1b76$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
